// extracted by mini-css-extract-plugin
module.exports = {"page":"settings_page__WLi3S","content":"settings_content__3ANzu"};